/**
 * Client-area runtime — behaviours that used to live as inline <script> blocks in
 * layout_default.html.twig. Moved into the bundle so the page source stays clean and
 * the scripts are cacheable. Each is a self-contained IIFE that no-ops when its target
 * elements are absent, so it is safe to load on every client page.
 *
 * Loaded from assets/meroserver.js. The bundle is deferred, so the DOM is fully parsed
 * by the time this runs; each IIFE still guards readyState for safety.
 */

// ── Order-flow skeleton reveal (only acts when the order skeleton is present) ──
                (function () {
                    function revealOrderPage() {
                        requestAnimationFrame(function () {
                            requestAnimationFrame(function () {
                                document.documentElement.classList.add('order-page-ready');
                                var content = document.getElementById('order-page-content');
                                var skeleton = document.getElementById('order-page-skeleton');
                                if (content) content.setAttribute('aria-busy', 'false');
                                window.setTimeout(function () {
                                    if (skeleton) skeleton.hidden = true;
                                }, 240);
                            });
                        });
                    }
                    if (document.readyState === 'loading') {
                        document.addEventListener('DOMContentLoaded', revealOrderPage, { once: true });
                    } else {
                        revealOrderPage();
                    }
                    window.setTimeout(revealOrderPage, 4000);
                })();

// ── api-link click handler (mirrors Huraga's bb.apiLink) ──────────────────────
(function () {
    // Rejects external URLs — only allows same-origin or root-relative paths.
    function safeRedirect(url) {
        if (!url) return;
        try {
            var parsed = new URL(url, window.location.origin);
            if (parsed.origin !== window.location.origin) return;
            window.location.href = parsed.href;
        } catch (_) {
            // Relative path (no host) — always safe
            if (url.charAt(0) === '/') window.location.href = url;
        }
    }

    // ── api-link handler ───────────────────────────────────────────────────────
    // Mirrors the bb.apiLink() behaviour from the Huraga theme bundle.
    // Intercepts clicks on <a class="api-link">, calls the API, then:
    //   data-api-jsonp="fnName"  → calls window.fnName(result)  (e.g. cPanel SSO)
    //   data-api-redirect="url" → navigates to url (same-origin or relative only)
    //   data-api-reload (any)   → reloads the page
    //   default                 → shows a success notification
    function initApiLinks() {
        var links = document.getElementsByClassName('api-link');
        for (var i = 0; i < links.length; i++) {
            (function (el) {
                el.addEventListener('click', function (e) {
                    e.preventDefault();
                    var href = el.getAttribute('href');
                    if (!href) return;
                    if (el.dataset.apiConfirm && !window.confirm(el.dataset.apiConfirm)) return;
                    API.makeRequest('GET', href, {}, function (res) {
                        var result   = res && res.result !== undefined ? res.result : res;
                        var jsonpFn  = el.dataset.apiJsonp;
                        var redirect = el.dataset.apiRedirect;
                        if (jsonpFn && typeof window[jsonpFn] === 'function') {
                            window[jsonpFn](result);
                        } else if (redirect) {
                            safeRedirect(redirect);
                        } else if ('apiReload' in el.dataset) {
                            window.location.reload();
                        } else {
                            FBPanel.message('Action completed successfully.', 'success');
                            window.location.reload();
                        }
                    }, function (err) {
                        FBPanel.message(
                            (err && err.message ? err.message : 'An error occurred') +
                            (err && err.code ? ' (' + err.code + ')' : ''),
                            'error'
                        );
                    });
                });
            })(links[i]);
        }
    }

    // ── api-form handler ───────────────────────────────────────────────────────
    // Intercepts <form class="api-form"> submit, serialises inputs and POSTs
    // to the form action, then follows data-api-redirect / data-api-reload.
    function initApiForms() {
        var forms = document.getElementsByClassName('api-form');
        for (var i = 0; i < forms.length; i++) {
            (function (form) {
                form.addEventListener('submit', function (e) {
                    e.preventDefault();
                    var method  = (form.getAttribute('method') || 'POST').toUpperCase();
                    var action  = form.getAttribute('action') || '';
                    var buttons = form.querySelectorAll('button:not([type="button"])');
                    var data    = {};
                    var fd = new FormData(form);
                    fd.forEach(function (v, k) { data[k] = v; });
                    if (!data.CSRFToken) data.CSRFToken = (document.querySelector('meta[name="csrf-token"]') || {}).content || '';
                    buttons.forEach(function (b) { b.disabled = true; });
                    API.makeRequest(method, action, data, function (res) {
                        buttons.forEach(function (b) { b.disabled = false; });
                        var redirect = form.dataset.apiRedirect;
                        if (redirect) {
                            window.location.href = redirect;
                        } else if ('apiReload' in form.dataset) {
                            window.location.reload();
                        } else {
                            var msg = form.dataset.apiMsg
                                || (res && typeof res.result === 'string' ? res.result : 'Saved successfully.');
                            FBPanel.message(msg, 'success');
                            if (form.dataset.closePanel) {
                                window.dispatchEvent(new CustomEvent('acct-panel-close'));
                            }
                            if (form.dataset.closeModal) {
                                window.dispatchEvent(new CustomEvent('modal-close', { detail: { modal: form.dataset.closeModal } }));
                            }
                        }
                    }, function (err) {
                        buttons.forEach(function (b) { b.disabled = false; });
                        FBPanel.message(
                            (err && err.message ? err.message : 'An error occurred') +
                            (err && err.code ? ' (' + err.code + ')' : ''),
                            'error'
                        );
                    });
                });
            })(forms[i]);
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        initApiLinks();
        initApiForms();
    });
}());

// ── Ajax region navigation (data-ajax-region) — exposes window.ajaxNavigate ────
/**
 * Ajax-navigate same-page filter/tab/pagination links instead of a full
 * document reload. A template opts in by wrapping the region(s) that should
 * update — e.g. tabs + list + pagination — in `<div data-ajax-region="some-id">`
 * (a page can declare more than one, swapped together on every nav).
 *
 * A same-page link (only the query string differs) clicked inside a region
 * is intercepted: the target URL is re-fetched with the X-Requested-With
 * header so the server renders it through layout_blank.html.twig instead of
 * this layout (see request.ajax — every meroserver page template already
 * extends the blank layout when that flag is set), the response's matching
 * [data-ajax-region] fragments replace the current ones in place, and the
 * URL updates via pushState. Falls back to a normal navigation on any
 * fetch/parse failure, or when a page declares no regions.
 */
(function () {
    function isSamePageLink(a) {
        if (!a || a.tagName !== 'A') return false;
        if (a.target && a.target !== '_self') return false;
        if (a.hasAttribute('download') || a.dataset.ajaxSkip !== undefined) return false;
        var href = a.getAttribute('href');
        if (!href || href.charAt(0) === '#') return false;
        var url;
        try { url = new URL(a.href, window.location.href); } catch (e) { return false; }
        return url.origin === window.location.origin && url.pathname === window.location.pathname;
    }

    function ajaxNavigate(url, opts) {
        opts = opts || {};
        var regions = document.querySelectorAll('[data-ajax-region]');
        if (!regions.length) { window.location = url; return; }

        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (res) {
                if (!res.ok) { throw new Error('HTTP ' + res.status); }
                return res.text();
            })
            .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var swapped = 0;
                regions.forEach(function (current) {
                    var id = current.getAttribute('data-ajax-region');
                    var fresh = doc.querySelector('[data-ajax-region="' + id + '"]');
                    if (fresh) { current.replaceWith(fresh); swapped++; }
                });
                if (!swapped) { throw new Error('no matching data-ajax-region in response'); }
                if (opts.push !== false) { history.pushState({ ajaxUrl: url }, '', url); }
                // Not syncing document.title from doc.title: the fetched response
                // renders through layout_blank.html.twig, whose <title> lacks the
                // " — {company}" suffix this layout appends, and none of today's
                // ajax regions change the page's subject anyway.
                document.dispatchEvent(new CustomEvent('ajax:navigated', { detail: { url: url } }));
            })
            .catch(function (err) {
                console.warn('[ajaxNavigate] falling back to full page load:', err);
                window.location = url;
            });
    }
    window.ajaxNavigate = ajaxNavigate;

    // Delegated on document (not the regions) so freshly-swapped-in links
    // never need rebinding.
    document.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var a = e.target.closest('a');
        if (!a || !a.closest('[data-ajax-region]') || !isSamePageLink(a)) return;
        e.preventDefault();
        ajaxNavigate(a.href);
    });

    window.addEventListener('popstate', function () {
        if (document.querySelector('[data-ajax-region]')) {
            ajaxNavigate(window.location.href, { push: false });
        }
    });
})();
